import { TableCell, styled } from '@/core/ui';
export const TableCellStyled = styled(TableCell)(({ theme }) => ({
    border: 0,
    padding: theme.spacing(2, 0, 2),
}));
